import UncontrolledPopover from 'components/SafeUncontrolledPopover';
import React, { useRef } from 'react';
import { FormattedMessage } from 'react-intl';

interface RatingCommentsFormHelperProps {
  personPreferredName?: string;
  campaignHasCalibrationPhase?: boolean;
  hideRatingCommentsToDirectReport: boolean;
}

export const RatingCommentsFormHelper: React.FC<
  RatingCommentsFormHelperProps
> = ({
  personPreferredName,
  campaignHasCalibrationPhase,
  hideRatingCommentsToDirectReport,
}) => {
  const ratingCommentLearnMoreRef = useRef<HTMLElement | undefined>();

  if (!hideRatingCommentsToDirectReport) {
    return (
      <span>
        <FormattedMessage
          id="app.views.person.person_performance.rating_comments_form_helper.note_these_comments_will_be_visible_to_direct_report"
          defaultMessage="Please note these comments will be visible to {personPreferredName}."
          values={{ personPreferredName }}
        />
      </span>
    );
  }

  return (
    <>
      <span>
        <FormattedMessage
          id="app.views.person.person_performance.not_visible_to_person"
          defaultMessage="These comments are not visible to {personPreferredName}."
          values={{ personPreferredName: personPreferredName }}
        />{' '}
        <span
          className="text-primary"
          role="button"
          // @ts-expect-error
          ref={ratingCommentLearnMoreRef}
        >
          <FormattedMessage
            id="app.views.person.person_performance.learn_more"
            defaultMessage="Learn more"
          />
        </span>
      </span>
      <UncontrolledPopover
        delay={50}
        trigger={'click'}
        placement="top"
        target={ratingCommentLearnMoreRef}
      >
        {campaignHasCalibrationPhase ? (
          <FormattedMessage
            id="app.views.person.person_performance.rating_comments_helpet_text_with_calibrations"
            defaultMessage="These comments will be referenced as part of the calibration process which will review equity and fairness across manager groups."
          />
        ) : (
          <FormattedMessage
            id="app.views.person.person_performance.rating_comments_helpet_text_without_calibrations"
            defaultMessage="These comments will be referenced only by managers and your HR/People admins."
          />
        )}
      </UncontrolledPopover>
    </>
  );
};
